import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";

@Form({ title: "Credit Summary Config" })
export default class CreditSummaryConfig {
	@Input({ type: InputType.CHECKBOX, title: "Enable Year Filter" })
	public enableYearFilter?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/creditSummary/CreditSummaryConfig.ts